const __WEBPACK_NAMESPACE_OBJECT__ = require("next/dist/client/components/action-async-storage.external.js");